export const REQUEST_SOURCES = 'dt/sources/REQUEST_SOURCES';
export const RECEIVE_SOURCES = 'dt/sources/RECEIVE_SOURCES';
export const DELETE_SOURCE = 'dt/sources/DELETE_SOURCE';
export const UPDATE_SOURCE = 'dt/sources/UPDATE_SOURCE';
export const CREATE_SOURCE = 'dt/sources/CREATE_SOURCE';
export const IMPORT_SOURCE = 'dt/sources/IMPORT_SOURCE';
export const RESET_SOURCES = 'dt/sources/RESET_SOURCES';
export const RECEIVE_SYNC_HEALTH = 'dt/sources/RECEIVE_SYNC_HEALTH';
export const REQUEST_CONNECTIVITY = 'dt/sources/REQUEST_CONNECTIVITY';
export const RECEIVE_CONNECTIVITY = 'dt/sources/RECEIVE_CONNECTIVITY';
export const REQUEST_SITE_VARIABLES = 'dt/sources/REQUEST_SITE_VARIABLES';
export const RECEIVE_VARIABLE = 'dt/sources/RECEIVE_VARIABLE';
export const REMOVE_VARIABLE = 'dt/sources/REMOVE_VARIABLE';
export const RECEIVE_SITE_VARIABLES = 'dt/sources/RECEIVE_SITE_VARIABLES';
export const CREATE_SOURCE_VARIABLES = 'dt/components/CREATE_SOURCE_VARIABLES';
export const UPDATE_SOURCE_VARIABLE = 'dt/components/UPDATE_SOURCE_VARIABLE';
export const DELETE_SOURCE_VARIABLE = 'dt/components/DELETE_SOURCE_VARIABLE';
export const UPLOAD_RISK_CONFIG_EXCEL = 'dt/components/UPLOAD_RISK_CONFIG_EXCEL_SHEET';
export const UPLOAD_TFR_CLASSIFICIATION_CONFIG = 'dt/sources/UPLOAD_TFR_CLASSIFICIATION_CONFIG';
export const UPLOAD_SWITCHGEAR_MONITORING_CONFIG = 'dt/sources/UPLOAD_SWITCHGEAR_MONITORING_CONFIG';

export const requestSources = ({ siteId, withVariables = true }) => ({
  type: REQUEST_SOURCES,
  siteId,
  withVariables,
});

export const receiveSources = (sources, sourceTypes, siteVariablesIndex, siteId) => ({
  type: RECEIVE_SOURCES,
  sources,
  sourceTypes,
  siteVariablesIndex,
  siteId,
  ...(siteVariablesIndex ? { siteVariablesUpdatedAt: Date.now() } : {}),
  sourcesUpdatedAt: Date.now(),
});

export const receiveSyncStatus = (siteId, syncHealth) => ({
  type: RECEIVE_SYNC_HEALTH,
  siteId,
  syncHealth,
});

export const deleteSource = (siteId, sourceId) => ({
  type: DELETE_SOURCE,
  siteId,
  sourceId,
});

export const updateSource = (
  siteId,
  sourceId,
  data,
  { successMessage, errorMessage, onSuccess, onError } = {}
) => ({
  type: UPDATE_SOURCE,
  siteId,
  sourceId,
  data,
  successMessage,
  errorMessage,
  onSuccess,
  onError,
});

export const createSource = (data, { onSuccess, onError } = {}) => ({
  type: CREATE_SOURCE,
  data,
  onSuccess,
  onError,
});

export const importSource = (siteId, sourceId, onComplete, body) => ({
  type: IMPORT_SOURCE,
  siteId,
  sourceId,
  onComplete,
  body,
});

export const resetSources = () => ({
  type: RESET_SOURCES,
});

export const requestSiteVariables = () => ({
  type: REQUEST_SITE_VARIABLES,
});

export const receiveVariable = (variable) => ({
  type: RECEIVE_VARIABLE,
  variable,
  siteVariablesUpdatedAt: Date.now(),
});

export const removeVariable = (variableId) => ({
  type: REMOVE_VARIABLE,
  variableId,
  siteVariablesUpdatedAt: Date.now(),
});

export const receiveSiteVariables = (siteVariablesIndex) => ({
  type: RECEIVE_SITE_VARIABLES,
  siteVariablesIndex,
  siteVariablesUpdatedAt: Date.now(),
});

export const requestConnectivity = (siteId) => ({
  type: REQUEST_CONNECTIVITY,
  siteId,
});

export const receiveConnectivity = (sourceConnectivity = []) => ({
  type: RECEIVE_CONNECTIVITY,
  sourceConnectivity,
});

export const createVariables = (
  sourceId,
  data,
  successCallback = null,
  failureCallback = null,
  doNotify = true
) => ({
  type: CREATE_SOURCE_VARIABLES,
  sourceId,
  data,
  successCallback,
  failureCallback,
  doNotify,
});

export const updateVariable = (
  sourceId,
  variableId,
  data,
  successCallback = null,
  failureCallback = null,
  doNotify = true
) => ({
  type: UPDATE_SOURCE_VARIABLE,
  sourceId,
  variableId,
  data,
  successCallback,
  failureCallback,
  doNotify,
});

export const deleteVariable = (
  sourceId,
  variableId,
  isAttribute = false,
  callback = null,
  doNotify = true
) => ({
  type: DELETE_SOURCE_VARIABLE,
  sourceId,
  variableId,
  isAttribute,
  callback,
  doNotify,
});

export const uploadRiskConfigExcel = (sourceId, file, siteId, org, onComplete) => ({
  type: UPLOAD_RISK_CONFIG_EXCEL,
  sourceId,
  file,
  siteId,
  org,
  onComplete,
});

export const uploadTFRClassificationConfig = (siteId, sourceId, configuration, fileName) => ({
  type: UPLOAD_TFR_CLASSIFICIATION_CONFIG,
  siteId,
  sourceId,
  configuration,
  fileName,
});

export const uploadSwitchgearMonitoringConfig = (siteId, sourceId, configuration, fileName) => ({
  type: UPLOAD_SWITCHGEAR_MONITORING_CONFIG,
  siteId,
  sourceId,
  configuration,
  fileName,
});
